import React, { useEffect, useRef, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Select from 'react-select';
import { CModal } from '@coreui/react';
import Swal from 'sweetalert2';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { generateAxiosInstanceCommonFileUpload } from '../../hooks/useAuthorizedRequestForFileUpload';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { deleteItem, findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';

const SectionUploadReferenceBook = () => {
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    const authorizedAxiosCommonFileUpload = generateAxiosInstanceCommonFileUpload()

    let instituteMasterId = localStorage.getItem("instituteMasterId")
    let sectionMasterId = localStorage.getItem("sectionMasterId")
    const pdfFile = useRef(null);

    const initialFormState = {
        instituteMasterId: instituteMasterId,
        sectionMasterId: sectionMasterId,
        filePath: '',
        tagMasterId: '',
        instituteGradeMasterIds: [''],
        fileName: '',
        title: '',
        description: ''
    }

    const [PdfBookData, setPdfBookData] = useState(initialFormState)
    const [PdfBookList, setPdfBookList] = useState([])
    const [editId, setEditId] = useState(null)
    const [visible, setVisible] = useState(false)
    const [showPdfLink, setShowPdfLink] = useState(false)
    const [tag, setTag] = useState([])
    const [classList, setClassList] = useState([])

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [tagNameSort, setTagNameSort] = useState(null);
    const [bookNameSort, setBookNameSort] = useState(null);
    const [pdfTitleSort, setPdfTitleSort] = useState(null);
    const [pdfDescriptionSort, setPdfDescriptionSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["sectionReferenceBookMasterDetails.instituteGradeMasterDetails.gradeName", "tagMasterDetails.tagName", "fileName", "title", "description"];


    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getGrade();
        getTag();
    }, []);

    const getGrade = () => {
        const apiUrl2 = `/get-institute-grade?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl2)
            .then(response => {
                setClassList(response.data.result.map((sub) => {
                    return {
                        value: sub.id,
                        label: sub.gradeName
                    }
                }))
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getTag = () => {
        const apiUrl = `/get-section-tag-master?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setTag(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getReferenceBookList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setCurrPage(1);
            setPdfBookList(await searchArray("B", getApiUrl(), searchKeys, searchValue.trim()))
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(PdfBookList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(PdfBookList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > PdfBookList.length) {
            endIndex = PdfBookList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(PdfBookList.slice(startIndex, endIndex));
    }, [PdfBookList, currPage, itemsPerPage]);

    const getApiUrl = () => {
        let apiUrl = `/get-section-reference-book?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&`;
        if (PdfBookData.tagMasterId !== '') {
            apiUrl += `tagMasterId=${PdfBookData.tagMasterId}&`;
        }
        if (PdfBookData.instituteGradeMasterIds.length != 0) {
            apiUrl += `instituteGradeMasterIds=${PdfBookData.instituteGradeMasterIds}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    useEffect(() => {
        getReferenceBookList();
    }, [PdfBookData.instituteGradeMasterIds, PdfBookData.tagMasterId]);

    const getReferenceBookList = async () => {
        try {
            const response = await authorizedAxiosSection.get(getApiUrl());
            setPdfBookList(response.data.result);
        } catch (error) {
            setPdfBookList([]);
            const errorMsg = error?.response?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        }
    }

    const handleInputChange = (e) => {
        setPdfBookData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const handleChangeBoard = (selectedOptions) => {
        const selectedIds = selectedOptions?.map((option) => option.value.toString());
        setPdfBookData((prevData) => {
            return {
                ...prevData,
                instituteGradeMasterIds: selectedIds,
            }
        })
    }

    const initialErrorState = {

    }
    const [error, setError] = useState(initialErrorState)
    const validateForm = () => {
        return Object.values(error).every((error) => error === '') && Object.values(PdfBookData).every((value) => typeof (value) == "string" ? value !== '' : value.length !== 0)
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(PdfBookData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [PdfBookData])

    const handleUploadLogo = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const fileName = file.name.split(".")[0];
        const fileExtension = file.name.split(".").pop().toLowerCase();
        const maxFileSize = 50 * 1024 * 1024; // 50MB

        if (fileExtension !== "pdf") {
            e.target.value = ''; // Reset the file input
            return Swal.fire({ text: "Only PDF files are supported" });
        }

        if (file.size > maxFileSize) {
            e.target.value = ''; // Reset the file input
            return Swal.fire({ text: "Max size 50MB file supported" });
        }

        setLoading(true);
        const body = new FormData();
        body.append("file", file);
        body.append("flag", "2"); // 2 -> content path in S3 bucket

        try {
            const apiUrl = "uploadfile-v2";
            const response = await authorizedAxiosCommonFileUpload.post(apiUrl, body);
            const { result } = response.data;

            setPdfBookData(prevData => ({
                ...prevData,
                [e.target.name]: result,
                fileName: fileName,
            }));
        } catch (err) {
            const errorMsg = err?.response?.data?.error || "Something went wrong!";
            Swal.fire({ text: errorMsg });
        } finally {
            setLoading(false);
        }
    };

    const addLesson = async () => {
        if (validateForm()) {
            try {
                setLoading(true);
                const apiUrl = `/add-section-reference-book`;
                const response = await authorizedAxiosSection.post(apiUrl, PdfBookData);
                await getReferenceBookList();
                pdfFile.current.value = "";
                setPdfBookData((prevData) => {
                    return {
                        ...prevData,
                        filePath: '',
                        fileName: '',
                        title: '',
                        description: ''
                    }
                });

                setSaveId(response.data.result.id);
                setTagNameSort(null);
                setBookNameSort(null);
                setPdfTitleSort(null);
                setPdfDescriptionSort(null);

                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        } else {
            for (const [key, value] of Object.entries(PdfBookData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const deleteLesson = async (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            try {
                setLoading(true);
                const apiUrl = `/delete-section-reference-book?id=${id}`;
                const response = await authorizedAxiosSection.delete(apiUrl);
                const page = deleteItem(currPage, itemsPerPage, PdfBookList.length);
                await getReferenceBookList();
                setCurrPage(page);
                Swal.fire(
                    { text: response.data.message }
                );
            } catch (error) {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            } finally {
                setLoading(false);
            }
        }
    }

    const handleInputReset = () => {
        setPdfBookData(initialFormState);
        setEditId('');
        setPdfBookList([]);
        pdfFile.current.value = '';
        setError(initialErrorState);
    }

    useEffect(() => {
        if (tagNameSort == true || tagNameSort == false) {
            setBookNameSort(null);
            setPdfTitleSort(null);
            setPdfDescriptionSort(null);
        }
    }, [tagNameSort])

    useEffect(() => {
        if (bookNameSort == true || bookNameSort == false) {
            setTagNameSort(null);
            setPdfTitleSort(null);
            setPdfDescriptionSort(null);
        }
    }, [bookNameSort])

    useEffect(() => {
        if (pdfTitleSort == true || pdfTitleSort == false) {
            setTagNameSort(null);
            setBookNameSort(null);
            setPdfDescriptionSort(null);
        }
    }, [pdfTitleSort])

    useEffect(() => {
        if (pdfDescriptionSort == true || pdfDescriptionSort == false) {
            setTagNameSort(null);
            setBookNameSort(null);
            setPdfTitleSort(null);
        }
    }, [pdfDescriptionSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb my-0 ms-2">
                        <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                            <span>Dashboard</span>
                        </li>
                        <li className="breadcrumb-item active"><span>Section Upload Reference Book Master</span></li>
                    </ol>
                </nav>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa fa-upload"></i> Section Upload Refrence Book Master </b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                                                    <Select
                                                        value={classList.filter(option =>
                                                            PdfBookData.instituteGradeMasterIds && PdfBookData.instituteGradeMasterIds.includes(option.value.toString())
                                                        )}
                                                        isMulti
                                                        name="instituteGradeMasterIds"
                                                        options={classList}
                                                        className="basic-multi-select"
                                                        classNamePrefix="Select Board"
                                                        onChange={handleChangeBoard}
                                                    />
                                                    {error.instituteGradeMasterIds && <p style={{ color: 'red' }}>{error.instituteGradeMasterIds}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Tag:</label>
                                                    <select class="form-select" aria-label="Default select example" name='tagMasterId' onChange={handleInputChange} value={PdfBookData.tagMasterId}>
                                                        <option selected value={''} disabled>Select Tag</option>
                                                        {
                                                            tag?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.tagName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.tagMasterId && <p style={{ color: 'red' }}>{error.tagMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Upload Pdf Book : </label>
                                                    <label style={{ color: "red" }} > max 50 Mb pdf file supported</label>
                                                    <input type="file" className="form-control" name="filePath" onChange={handleUploadLogo} ref={pdfFile} />
                                                    {error.filePath && <p style={{ color: 'red' }}>{error.filePath}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>File Name:</label>
                                                    <input required type="text" className="form-control" name="fileName" value={PdfBookData.fileName} onChange={handleInputChange} />
                                                    {error.fileName && <p style={{ color: 'red' }}>{error.fileName}</p>}
                                                </div>


                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Title:</label>
                                                    <input required type="text" className="form-control" name="title" value={PdfBookData.title} onChange={handleInputChange} />
                                                    {error.title && <p style={{ color: 'red' }}>{error.title}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Description:</label>
                                                    <input required type="text" className="form-control" name="description" value={PdfBookData.description} onChange={handleInputChange} />
                                                    {error.description && <p style={{ color: 'red' }}>{error.description}</p>}
                                                </div>
                                            </div>
                                            <CModal
                                                visible={visible}
                                                onClose={() => setVisible(false)}
                                                aria-labelledby="LiveDemoExampleLabel"
                                            >
                                                <div className="book pdf-modal">
                                                    <iframe height={450} width={"100%"} className="page" src={showPdfLink}></iframe>
                                                    <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisible(false)}>
                                                        Close
                                                    </button>
                                                </div>
                                            </CModal>


                                            <div className="row">
                                                <div className="col-md-12 mt-3 d-flex justify-content-center button-container">
                                                    {!editId && <button className="btn btn-primary" type="button" onClick={addLesson}>Save</button>
                                                    }
                                                    <button className="btn btn-outline-danger delete_icon" type="button" onClick={handleInputReset}>Reset</button>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope="col">
                                                                            Class
                                                                        </th>
                                                                        <th scope="col">
                                                                            Tag Name
                                                                            <SortIcon sortState={tagNameSort} setSortState={setTagNameSort} setData={setPdfBookList} setCurrPage={setCurrPage} sortingPath={"tagMasterDetails.tagName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Book Name
                                                                            <SortIcon sortState={bookNameSort} setSortState={setBookNameSort} setData={setPdfBookList} setCurrPage={setCurrPage} sortingPath={"fileName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Book Title
                                                                            <SortIcon sortState={pdfTitleSort} setSortState={setPdfTitleSort} setData={setPdfBookList} setCurrPage={setCurrPage} sortingPath={"title"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Book Description
                                                                            <SortIcon sortState={pdfDescriptionSort} setSortState={setPdfDescriptionSort} setData={setPdfBookList} setCurrPage={setCurrPage} sortingPath={"description"} />
                                                                        </th>
                                                                        <th scope="col">Book</th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData.length > 0 ?
                                                                            displayedData.map((lesson, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{lesson.sectionReferenceBookMasterDetails.map(i => `${i.instituteGradeMasterDetails.gradeName}`).join(", ")}</td>
                                                                                        <td>{lesson?.tagMasterDetails?.tagName}</td>
                                                                                        <td>{lesson.fileName}</td>
                                                                                        <td>{lesson.title}</td>
                                                                                        <td>{lesson.description}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-primary view_icon" type="button" onClick={() => {
                                                                                                setShowPdfLink(lesson.filePath)
                                                                                                setVisible(true)
                                                                                            }}><i class="fa fa-eye" ></i> Book</button>
                                                                                        </td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" onClick={() => deleteLesson(lesson.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Reference Book Available</th>
                                                                            </tr>)
                                                                    }

                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={PdfBookList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default SectionUploadReferenceBook;